module.exports = __webpack_public_path__ + "img/formBanner.71b2f9b8.jpg";